import * as React from 'react';
import { AddStroke16, Button } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';
import { showFavoritesFoldersList, showModalCreateFolder } from '@cian/favorites-assign-widget';
import { selectUser } from '../../selectors';
import { selectFolders } from '../../selectors/folders';

interface IAddToFolderButtonContainerProps {
  entityId: number;
}

export function AddToFolderButtonContainer({ entityId }: IAddToFolderButtonContainerProps) {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const folders = useSelector(selectFolders);

  const handleClick = React.useCallback(() => {
    if (user.isAuthenticated) {
      dispatch((folders.length ? showFavoritesFoldersList : showModalCreateFolder)({ offerIds: [entityId] }));
    } else {
      window.waitForLoginPopup();
    }
  }, [entityId, user]);

  return (
    <Button size="XS" theme="fill_secondary" onClick={handleClick} beforeIcon={<AddStroke16 color="primary_100" />}>
      Сохранить в подборку
    </Button>
  );
}
